import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsEvent from "components/Dashboard/Forms/Event";

export default function DashboardFormEvent(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"events"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsEvent />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}